import { type ReactNode, type FC } from 'react'
import classNames from 'classnames'
import styles from './styles.module.scss'

export type ITooltipDefaultProps = {
  label?: ReactNode
  color?: 'white' | 'red' | 'yellow'
  icons?: string[]
  breakWord?: boolean
  ariaLabel?: string
}

export const TooltipDefault: FC<ITooltipDefaultProps> = ({
  label,
  icons = [],
  color,
  breakWord = false,
  ariaLabel = '',
}) => {
  const hasIcons = Boolean(icons.length)
  const tooltipAriaLabel = `TooltipDefault_${ariaLabel}`

  return (
    <div
      className={classNames(styles.wrap, {
        [styles.breakWord]: breakWord,
      })}
      aria-label={tooltipAriaLabel}
    >
      <div className={classNames(styles.label, color && styles[color])}>{label}</div>

      {hasIcons && (
        <div className={styles.icons}>
          {icons.map((icon, index) => {
            return <div key={index}>{icon}</div>
          })}
        </div>
      )}
    </div>
  )
}
